const TYPE = {
  google: 'google-calendar',
  office365: 'office365-calendar'
}

function formatDate(date: string | Date, type: string): string | null | undefined {
  switch (type) {
    case TYPE.google:
      return date ? new Date(date).toISOString().replace(/-|:|\.\d+/g, '') : null
    case TYPE.office365:
      return encodeURIComponent(new Date(date).toISOString())
    default:
      return date as string
  }
}

function formatString(string: string): string {
  return encodeURIComponent(string).replace(/%20/g, '+')
}

function formatUrl(header: string, parameters: Record<string, any>): string {
  let url = header
  Object.keys(parameters).forEach((key) => {
    if (parameters[key]) {
      url += `&${key}=${parameters[key]}`
    }
  })
  return url
}

function commonParametersHandler({
  title, location, details, start, end
}: { title: string; location: string; details: string; start: string | Date; end: string | Date }) {
  const parameters: Record<string, any> = {
    text: formatString(title),
    details: formatString(details),
    subject: formatString(title),
    location: formatString(location),
    body: formatString(details),
    startdt: formatDate(start, TYPE.office365),
    enddt: formatDate(end, TYPE.office365),
    allday: false,
  }
  if (start && end) {
    parameters.dates = `${formatDate(start, TYPE.google)}/${formatDate(end, TYPE.google)}`
  }
  return parameters
}

export class AddToCalendar {
  static getLink({
    url, title, location, details, start, end
  }: { url: string; title: string; location: string; details: string; start: string | Date; end: string | Date }) {
    const parameters = commonParametersHandler({
      title, location, details, start, end
    })
    return formatUrl(url, parameters)
  }

  // static getTypes() {
  //   return {
  //     google: 'google-calendar',
  //     office365: 'office365-calendar'
  //   }
  // }
}

export default {
  AddToCalendar
}
